import aaTrackEvent from '../utils/aaTrackEvent';
import { HEADER_LANGUAGE_DROPDOWN_OPEN } from './constants';

export const trackLanguageDropdownOpen = () => {
  aaTrackEvent(HEADER_LANGUAGE_DROPDOWN_OPEN);
};
